import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export interface Me {
  userId: string;
  email: string;
  name: string | null;
  role: "superadmin" | "admin" | "employee";
  isAdmin: boolean;
  isSuperadmin: boolean;
}

/**
 * The gate check. ⚠ `enabled` only once Clerk has loaded with a session: asked
 * earlier, the request goes out without a token, the 401 is cached as the
 * answer (no retry, on purpose), and a signed-in person is told to sign in.
 * That shipped once; Home learnt it first.
 */
export function useMe(enabled: boolean) {
  return useQuery({
    queryKey: ["me"],
    queryFn: () => api<Me>("/me"),
    enabled,
    retry: false,
    staleTime: 60_000,
  });
}

export function displayName(me: Pick<Me, "name" | "email">): string {
  return me.name?.trim() || me.email;
}
